<template>
  <select
    v-model="selected"
    class="form-control fontSize16"
    @change="getCountry()"
  >
    <option v-for="opt in options" :value="opt" :key="opt.country">
      {{ opt.country === area ? `${opt.country} [定位]` : opt.country }}
    </option>
  </select>
</template>
<script>
import { cookies } from '@/utils/cookies'
import { counties } from '@/mocks/index.js'
export default {
  props: {
    options: {
      type: Array,
      default() {
        return counties
      },
    },
  },
  data() {
    return {
      selected: '',
      area: cookies.get('GladArea'),
    }
  },
  mounted() {
    // console.log('====>area', area)
    let locatedCounty = this.options.find((opt) => opt.country === this.area)
    if (locatedCounty) {
      this.$set(this, 'selected', locatedCounty)
      this.$emit('change-county', this.selected)
    }
  },
  methods: {
    getCountry() {
      this.$emit('change-county', this.selected)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/tool/CountrySelect.vue